import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { Link, withRouter } from 'react-router-dom'
import AddIcon from '@material-ui/icons/Add'

import CampaignPage from 'Containers/Campaigns/Page'
import { authorization } from 'Module/Auth/Auth'

import { CityPlansFiltersWrapper } from 'Components/Campaigns/Page/CityPlans/CityPlansFiltersWrapper'
import { CityPlansTableLinks } from 'Components/Campaigns/Page/CityPlans/CityPlansTableLinks'
import { CityPlansWrapper } from 'Components/Campaigns/Page/CityPlans/CityPlansWrapper'
import { LayoutDashboard } from 'Components/Layout/Dashboard'
import { LinkEdit } from 'Components/Link/Edit'
import { LinkView } from 'Components/Link/View'
import { Table } from 'Components/Table'
import { Td } from 'Components/Table/Td'
import { Th } from 'Components/Table/Th'
import { Tr } from 'Components/Table/Tr'
import { RedirectRow } from 'Containers/RedirectRow'
import { setCityPlansByCampaignIdSortBy } from 'Reducers/Campaigns/actions'
import { numberFormatter } from './../../../../Utils/Formatters'
import { getTimeOfDayCheckInRanges } from './../../../../shared/libraries/utils/date'
import {
  MISSION_STATUS_ENUM,
  CAMPAIGN_ENUM_TYPES,
} from '../../../../shared/constants'
import getCampaignsCityPlans from './gql'
import { normalizeGraphQLConnection } from '../../../../shared/graphql/utils'
import StyledIconButton from '../../../../Components/Form/StyledIconButton'
import { differenceInMinutes } from 'date-fns'
import { calculateTimeOfDay } from '../../../../Utils/Mission/index'
import { changeTimezone } from '../../../../shared/libraries/utils/date'
const CityPlans = ({
  match: {
    params: { campaignId },
  },
  match,
  match: { url },
  setCityPlansByCampaignIdSortBy,
  sortBy,
  nav,
  history,
  campaign,
}) => {
  const [cityPlans, setCityPlans] = useState([])

  useEffect(() => {
    getData()
  }, [])

  const getData = async () => {
    const { data } = await getCampaignsCityPlans(campaignId)
    const formattedData = formatData(data.campaign.cityPlans.nodes)

    const sortedData = formattedData.sort((dataA, dataB) => {
      let nameA = dataA.city.name.toUpperCase()
      let nameB = dataB.city.name.toUpperCase()
      if (nameA < nameB) {
        return -1
      }
      if (nameA > nameB) {
        return 1
      }
      return 0
    })

    setCityPlans(sortedData)
  }
  /**
   * Render table with city plans list
   * @returns {*}
   */
  const renderCityPlansTable = () => {
    const { cityPlansData, totals } = cityPlans.reduce(
      (acc, cityPlan) => {
        const cityPlanMissionsData = getCityPlansTableRowData(cityPlan)
        acc.cityPlansData.push(cityPlanMissionsData)
        Object.entries(cityPlanMissionsData).forEach(
          ([key, value]) => (acc.totals[key] = (acc.totals[key] || 0) + value),
        )
        return acc
      },
      { cityPlansData: [], totals: {} },
    )

    return (
      <Table>
        <thead>
          <Tr>
            <Th className="sortable" id={'city.name'} onClick={changeSort}>
              City
            </Th>
            <Th className="sortable" id={'totalMissions'} onClick={changeSort}>
              Total # Missions
            </Th>
            <Th
              className="sortable"
              id={'completedMissions'}
              onClick={changeSort}
            >
              Paid # Missions
            </Th>
            <Th
              className="sortable"
              id={'completedMissions'}
              onClick={changeSort}
            >
              Completed # Missions
            </Th>
            <Th
              className="sortable"
              id={'underReviewMissions'}
              onClick={changeSort}
            >
              under-review # Missions
            </Th>
            <Th
              className="sortable"
              id={'checkedInMissions'}
              onClick={changeSort}
            >
              checked-in # Missions
            </Th>
            <Th className="sortable" id={'bookedMissions'} onClick={changeSort}>
              booked # Missions
            </Th>
            <Th className="sortable" id={'bookedMissions'} onClick={changeSort}>
              available # Missions
            </Th>
            <Th className="align-right">Actions</Th>
          </Tr>
        </thead>
        <tbody>{cityPlansData.map(renderCityPlanRow)}</tbody>
        <tfoot>
          {renderCityPlanRow({
            ...totals,
            id: null,
            name: 'Total',
            cityPlanUrl: null,
          })}
        </tfoot>
      </Table>
    )
  }

  /**
   * Render a row of city plans table
   *
   * @param cityPlan
   * @returns {*}
   */
  const getCityPlansTableRowData = cityPlan => {
    const cityPlanUrl =
      campaign.type === CAMPAIGN_ENUM_TYPES.LETTERBOX
        ? `${url}/${cityPlan.id}/missions`
        : `${url}/${cityPlan.id}`
    const missionsCount = cityPlan.missions.totalCount
    const missionStatusesCount = countMissionStatuses(cityPlan)

    const {
      completedCount,
      paidCount,
      underReviewCount,
      checkedInCount,
      shouldCheckedInCount,
      bookedMissionsCount,
      availableMissionsCount,
    } = missionStatusesCount

    return {
      id: cityPlan.id,
      name: cityPlan.city.name,
      completedCount,
      paidCount,
      underReviewCount,
      checkedInCount,
      shouldCheckedInCount,
      bookedMissionsCount,
      availableMissionsCount,
      cityPlanUrl,
      missionsCount,
    }
  }

  const countMissionStatuses = cityPlan =>
    cityPlan.missions.edges.reduce(
      (acc, item) => {
        if (item.node.status == MISSION_STATUS_ENUM.COMPLETED) {
          acc.completedCount++
        }
        if (
          item.node.status == MISSION_STATUS_ENUM.PAID &&
          !item.node.cancelled
        ) {
          acc.paidCount++
        }
        if (item.node.status == MISSION_STATUS_ENUM.UNDER_REVIEW) {
          acc.underReviewCount++
        }
        if (item.node.status == MISSION_STATUS_ENUM.CHECKED_IN) {
          acc.checkedInCount++
        }
        if (item.node.status == MISSION_STATUS_ENUM.BOOKED) {
          const timeOfDay = calculateTimeOfDay(
            changeTimezone(new Date().toISOString(), cityPlan.city.timezone),
            cityPlan.city.morningCheckingTime,
            cityPlan.city.lunchCheckInTime,
            cityPlan.city.afternoonCheckInTime,
          )

          const { checkInTimeBefore } = getTimeOfDayCheckInRanges(
            cityPlan.city,
            timeOfDay,
          )

          const timeToMissionInMinutes = differenceInMinutes(
            new Date(),
            new Date(item.node.dateTime),
          )

          // Convert to the city's tz and then only compare the date parts
          const isSameDay =
            changeTimezone(
              new Date().toISOString(),
              cityPlan.city.timezone,
            ).split('T')[0] ===
            changeTimezone(
              new Date(item.node.dateTime).toISOString(),
              cityPlan.city.timezone,
            ).split('T')[0]

          if (
            isSameDay &&
            (timeToMissionInMinutes > 0 ||
              Math.abs(timeToMissionInMinutes) <= checkInTimeBefore)
          ) {
            acc.shouldCheckedInCount++
          }
          acc.bookedMissionsCount++
        }
        if (item.node.status == MISSION_STATUS_ENUM.AVAILABLE) {
          acc.availableMissionsCount++
        }
        return acc
      },
      {
        completedCount: 0,
        paidCount: 0,
        underReviewCount: 0,
        checkedInCount: 0,
        shouldCheckedInCount: 0,
        bookedMissionsCount: 0,
        availableMissionsCount: 0,
      },
    )

  const renderCityPlanRow = ({
    id,
    name,
    cityPlanUrl,
    completedCount,
    paidCount,
    underReviewCount,
    checkedInCount,
    shouldCheckedInCount,
    bookedMissionsCount,
    availableMissionsCount,
    missionsCount,
  }) => (
    <RedirectRow key={`city-plan-${name}`} to={cityPlanUrl}>
      <Td>{name}</Td>
      <Td>{missionsCount ? numberFormatter(missionsCount) : ''}</Td>
      <Td>{paidCount > 0 ? numberFormatter(paidCount) : ''}</Td>
      <Td>{completedCount > 0 ? numberFormatter(completedCount) : ''}</Td>
      <Td>{underReviewCount > 0 ? numberFormatter(underReviewCount) : ''}</Td>
      <Td>
        {checkedInCount > 0 ? numberFormatter(checkedInCount) : '-'}{' '}
        {shouldCheckedInCount > 0 || checkedInCount > 0
          ? '/ ' + numberFormatter(shouldCheckedInCount + checkedInCount)
          : ''}
      </Td>
      <Td>
        {bookedMissionsCount > 0 ? numberFormatter(bookedMissionsCount) : ''}
      </Td>
      <Td>
        {availableMissionsCount > 0
          ? numberFormatter(availableMissionsCount)
          : ''}
      </Td>
      <Td actions className="no-opacity">
        {id ? renderCityPlansTableLinks(id) : null}
      </Td>
    </RedirectRow>
  )
  /**
   * Render city plan table rows action links
   *
   * @param cityPlanId
   * @returns {*}
   */
  const renderCityPlansTableLinks = cityPlanId => {
    const cityPlanUrl =
      campaign.type === CAMPAIGN_ENUM_TYPES.LETTERBOX
        ? `${url}/${cityPlanId}/missions`
        : `${url}/${cityPlanId}`

    return (
      <CityPlansTableLinks>
        <LinkView to={cityPlanUrl.replace(/\/+/g, '/')} />
        {authorization.isAdmin() && (
          <LinkEdit to={`${url}/${cityPlanId}/edit`.replace(/\/+/g, '/')} />
        )}
      </CityPlansTableLinks>
    )
  }

  /**
   * Change the way how data is sorted (by column)
   *
   * @param event
   */
  const changeSort = event => {
    const columnName = event.target.id

    if (sortBy.columnName === columnName) {
      setCityPlansByCampaignIdSortBy({ ...sortBy, reverse: !sortBy.reverse })
    } else {
      setCityPlansByCampaignIdSortBy({ columnName, reverse: false })
    }
  }

  return (
    <CampaignPage
      active={nav}
      campaignId={campaignId}
      match={match}
      history={history}
    >
      <CityPlansWrapper>
        <LayoutDashboard>
          <CityPlansFiltersWrapper>
            {authorization.isAdmin() && (
              <Link
                style={{ display: 'flex', justifyContent: 'flex-end' }}
                to={`${url}/create`}
              >
                <StyledIconButton>
                  <AddIcon />
                </StyledIconButton>
              </Link>
            )}
          </CityPlansFiltersWrapper>
        </LayoutDashboard>
        {renderCityPlansTable()}
      </CityPlansWrapper>
    </CampaignPage>
  )
}

const mapStateToProps = (
  state,
  {
    match: {
      params: { campaignId },
    },
  },
) => ({
  cities: state.city.citiesList,
  sortBy: state.campaigns.cityPlansByCampaignIdSortBy,
  campaign: state.campaigns.campaigns[campaignId],
})

export default connect(
  mapStateToProps,
  {
    setCityPlansByCampaignIdSortBy,
  },
)(withRouter(CityPlans))

const formatData = cityPlans => {
  return cityPlans.map(cityPlan => {
    return {
      ...cityPlan,
      completedMissionsCount: normalizeGraphQLConnection(
        cityPlan.missions,
      ).filter(
        mission =>
          [MISSION_STATUS_ENUM.COMPLETED, MISSION_STATUS_ENUM.PAID].includes(
            mission.status,
          ) && !mission.cancelled,
      ).length,
    }
  })
}



// WEBPACK FOOTER //
// ./src/Containers/Campaigns/Page/CityPlans/index.js